import { render, staticRenderFns } from "./taxCategory.vue?vue&type=template&id=4b2d7d14&scoped=true&"
import script from "./taxCategory.vue?vue&type=script&lang=js&"
export * from "./taxCategory.vue?vue&type=script&lang=js&"
import style0 from "./taxCategory.vue?vue&type=style&index=0&id=4b2d7d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d7d14",
  null
  
)

export default component.exports